/** Shim tipis pengganti next/navigation supaya halaman hasil port tidak perlu diubah isinya.
 *  Dipakai oleh: pages/a/layout.tsx (usePathname), monitoring/articles & social/posts
 *  (useSearchParams), issues/detail-page.tsx (useParams). */
import { useLocation, useNavigate, useParams as useRRParams, useSearchParams as useRRSearchParams } from "react-router-dom";

export function usePathname(): string {
  return useLocation().pathname;
}

/** Next mengembalikan objek baca-saja; react-router mengembalikan tuple. Samakan bentuknya. */
export function useSearchParams(): URLSearchParams {
  const [sp] = useRRSearchParams();
  return sp;
}

export function useParams<T extends Record<string, string | undefined> = Record<string, string | undefined>>(): T {
  return useRRParams() as T;
}

export function useRouter() {
  const nav = useNavigate();
  return {
    push: (href: string) => nav(href),
    replace: (href: string) => nav(href, { replace: true }),
    back: () => nav(-1),
    refresh: () => window.location.reload(),
  };
}
